<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    ref="dividerRef"
    class="divider-animated"
    :class="{ visible: isVisible }"
  >
    <div class="divider-line"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const dividerRef = ref(null);
const isVisible = ref(false);
let observer = null;

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) isVisible.value = true;
      });
    },
    { threshold: 0.1 }
  );
  if (dividerRef.value) observer.observe(dividerRef.value);
});

onBeforeUnmount(() => {
  if (observer && dividerRef.value) observer.unobserve(dividerRef.value);
});
</script>

<style scoped lang="scss">
.divider-animated {
  width: calc(100% + 40px);
  margin: 30px -20px;
  overflow: hidden;

  .divider-line {
    width: 100%;
    height: 0;
    border: 1px solid #f0efff;
    transform-origin: center;
    transform: scaleX(0);
    transition: transform 0.4s ease-out;
  }

  &.visible .divider-line {
    transform: scaleX(1);
  }
}
</style>
